var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 25L25 41.7239V80H75V41.7239L50 25Z",
    fill: "#E4E6EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59H46V80H34V59Z",
    fill: "#445174"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 69H75V73H60V69Z",
    fill: "#445174"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9751 80.0794V65.6127L59.0418 62.5127L61.1084 65.6127V80.0794H56.9751Z",
    fill: "#838EAE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2417 80.0794V65.6127L67.3084 62.5127L69.375 65.6127V80.0794H65.2417Z",
    fill: "#838EAE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5088 80.0794V65.6127L75.5755 62.5127L77.6421 65.6127V80.0794H73.5088Z",
    fill: "#838EAE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50H47C45.343 50 44 48.657 44 47V41C44 39.343 45.343 38 47 38H53C54.657 38 56 39.343 56 41V47C56 48.657 54.657 50 53 50Z",
    fill: "#C8CCD8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56 43H51V38H49V43H44V45H49V50H51V45H56V43Z",
    fill: "#838EAE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41 69H43V71H41V69Z",
    fill: "#E4E6EC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24 72H26V80H24V72Z",
    fill: "#4C5A81"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31 67.8766C31 71.5405 28.5371 74 25.5 74C22.4629 74 20 71.5405 20 67.8766C20 65.4845 22.3441 59.6918 23.9721 55.9575C24.5287 54.6808 26.4724 54.6808 27.029 55.9575C28.6559 59.6918 31 65.4845 31 67.8766Z",
    fill: "#AF8EFF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19 79H81V81H19V79Z",
    fill: "#4C5A81"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6864 44L50 25.0284L22.3136 44L20 40.5569L50 20L80 40.5569L77.6864 44Z",
    fill: "#445174"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.f954ffdbcee54e54126b5bf06c9213c9.svg";
export { ForwardRef as ReactComponent };